import { capitalize } from 'lodash'

export const formatUserRole = (role: string) => {
  return capitalize(role.replace(/_/g, ' '))
}
